import { useLocation, Link } from "react-router-dom";
import useSeo from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: 'Página Não Encontrada | Pilar Manutenção Industrial',
    description: 'A página solicitada não foi encontrada. Retorne à página inicial da Pilar Manutenção Industrial.',
    keywords: 'Pilar Manutenção Industrial, erro 404, página não encontrada',
    canonical: 'https://www.pilarmanutencao.com.br/',
  });

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <span className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </span>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-gp-graphite">Página não encontrada</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">A página que você procura não existe ou foi movida.</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-6 py-3 rounded-sm font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap"
        >
          <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
          Voltar para a Home
        </Link>
      </div>
    </div>
  );
}